export function calculateSurchargeAmount(amount: number, surchargePercentage?: number | null) {
  if (surchargePercentage == null || surchargePercentage <= 0) return 0;

  return Math.round(amount * (surchargePercentage / 100) * 100) / 100;
}

export function hasConfiguredSurcharge(surchargePercentage: number | null | undefined) {
  return surchargePercentage != null && surchargePercentage > 0;
}

export function shouldApplySurcharge(
  surchargePercentage: number | null | undefined,
  cardCanSurcharge: boolean,
) {
  return hasConfiguredSurcharge(surchargePercentage) && cardCanSurcharge;
}

export function isColoradoZipCode(zipCode: string) {
  const normalized = zipCode.trim().slice(0, 5);
  if (!/^\d{5}$/.test(normalized)) return false;

  const numericZip = Number(normalized);
  return numericZip >= 80000 && numericZip <= 81699;
}

export function getSurchargeDisclosureType(zipCode: string) {
  return isColoradoZipCode(zipCode) ? "colorado" : "default";
}
